<template>
  <div id="demographics-tab-container" element-loading-background="#F7F8FC" v-loading="loading">
    <div v-for="demo in filteredDemographics" :key="demo.title">
      <el-card :class="{ blacklisted: demo.blacklisted }" shadow="hover" class="demo-card">

        <el-popconfirm
          v-if="!demo.blacklisted"
          title="Are you sure to blacklist this demographic?"
          icon="el-icon-info"
          icon-color="red"
          confirm-button-text="Yes"
          cancel-button-text="No"
          @onConfirm="blacklistNugget(demo)"
        >
          <span id="remove-nugget" slot="reference" class="delete">
            <el-tooltip class="item" effect="dark" content="Blacklist field" placement="left-start">
              <i class="el-icon-close-notification"></i>
            </el-tooltip>
          </span>
        </el-popconfirm>

        <span v-if="demo.blacklisted" id="blacklisted-nugget">
          <el-tooltip class="item" effect="dark" content="This field is blacklisted" placement="left-start">
            <i class="el-icon-star-on"></i>
          </el-tooltip>
        </span>

        <el-popconfirm
          title="Are you sure to permanently delete this?"
          icon="el-icon-info"
          icon-color="red"
          confirm-button-text="Yes"
          cancel-button-text="No"
          @onConfirm="removeNugget(demo)"
        >
          <span slot="reference" class="delete" style="float: right; cursor: pointer">
            <el-tooltip
              class="item"
              effect="dark"
              content="Remove from profile"
              placement="right-end"
            >
              <i class="el-icon-minus"></i>
            </el-tooltip>
          </span>
        </el-popconfirm>

        <span class="demo-title">{{ demo.title }}</span>
        <div v-if="demo.field === 'birth_date'">
          <span class="demo-value">{{ demo.label.split(" ")[0] }}</span>
        </div>
        <div v-else>
          <span class="demo-value">{{ demo.label }}</span>
        </div>
      </el-card>
    </div>
    <div
      v-if="blacklistedDemographics.length"
      @click="toggleBlacklist"
      id="blacklist-toggle"
      class="text-center"
    >
      <span v-if="!showBlacklisted">Show</span> <span v-else>Hide</span> Blacklisted Demographics
    </div>
  </div>
</template>

<script>
export default {
  name: 'DemographicsTab',
  data: () => ({
    showBlacklisted: false,
  }),
  computed: {
    filteredDemographics() {
      if (this.showBlacklisted) return this.demographics;
      return this.demographics.filter(demo => !demo.blacklisted);
    },
    blacklistedDemographics() {
      return this.demographics.filter(demo => demo.blacklisted);
    },
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    demographics: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    toggleBlacklist() {
      this.showBlacklisted = !this.showBlacklisted;
    },
    blacklistNugget(nugget) {
      this.$emit('blacklist', nugget);
    },
    removeNugget(nugget) {
      this.$emit('remove', nugget);
    },
    parsedDemoValue(nugget) {
      const additionalParsing = {
        'Birth date': () => nugget.label.match(/[\d]{4}-[\d]{2}-[\d]{2}/)[0],
      };
      return additionalParsing[nugget.title]() || nugget.label;
    },
  },
};
</script>

<style lang="scss" scoped>
.demo-title {
  display: block;
  font-size: 1.2em;
  font-weight: bold;
  color: #000;
  margin-bottom: 15px;
}

.demo-value {
  display: block;
  font-weight: light;
}

.demo-card {
  min-height: 100px;
  background-color: #fff;
  padding-bottom: 5px;
  margin-bottom: 15px;
  border: none;

  .delete {
    font-size: 1.2em;
    display: none;
  }

  :hover {
    .delete {
      display: block;
    }
  }
}

#demographics-tab-container {
  overflow-y: scroll;
  height: 430px;
  padding: 0 8px;
}

#blacklist-toggle {
  color: #808080;
  text-decoration: underline;
  margin-top: 30px;
  cursor: pointer;
}

#remove-nugget {
  float: right;
  cursor: pointer;
  margin-left: 10px;
}

#blacklisted-nugget {
  float: right;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// DemographicsTab.vue?5d04c594